var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { keyframes } from '@mui/material/styles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { Activity, UserX, UserCheck, Undo2, RefreshCcw } from 'lucide-react';
import ExportMenuButton from '../../../components/uiComponents/ExportMenuButton';
import CustomButton from '../../../components/buttonComponent/CustomButton';
import ActiveFilterChipsRow from '../components/ActiveFilterChipsRow';
import { baseColors } from '../../../Themes/colors';
import { FundingLogNewTag } from './FundingLogStyles';
import FundingLog from './FundingLog';
import { deriveFundingLogRoleTier, isFundingLogReviewerRole } from './useFundingLog';
import { FundingLogDetailsPanelWrapper } from '../BacklogApplicationStyles';
import { FUNDING_LOG_COUNTRY_OPTIONS } from '../../../config/constants';
import { formatCurrency } from '../../../utils/commonUtilities';
var refreshSpin = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n"], ["\n    from { transform: rotate(0deg); }\n    to { transform: rotate(360deg); }\n"])));
var L1_QUEUE_TABS = [
    { label: 'Funding In Progress', queueType: 'IN_PROGRESS' },
    { label: 'My Queue', queueType: 'MY_QUEUE' },
    { label: 'All', queueType: 'ALL' },
];
var L2_QUEUE_TABS = [
    { label: 'Funding In Progress', queueType: 'IN_PROGRESS' },
    { label: 'Final Review', queueType: 'L2_REVIEW_QUEUE' },
    { label: 'My Queue', queueType: 'MY_QUEUE' },
    { label: 'All', queueType: 'ALL' },
];
var EXPORT_HIDDEN_QUEUE_TYPES = ['ALL'];
var QUEUE_SUMMARY_CARDS = [
    { label: 'Funding In Progress', queueType: 'IN_PROGRESS', color: baseColors.darkPreset[10], icon: Activity },
    { label: 'Unassigned', queueType: 'UNASSIGNED', color: baseColors.errorPreset[20], icon: UserX },
    { label: 'My Queue', queueType: 'MY_QUEUE', color: baseColors.successPreset[30], icon: UserCheck },
    { label: 'Returned to Sales Support', queueType: 'RETURNED_TO_SALES_SUPPORT', color: baseColors.warningPreset[20], icon: Undo2 },
];
var QueueSummaryCard = function (_a) {
    var label = _a.label, count = _a.count, amount = _a.amount, splitAmounts = _a.splitAmounts, currencyLabel = _a.currencyLabel, hideEmptyAmount = _a.hideEmptyAmount, newCount = _a.newCount, color = _a.color, Icon = _a.icon, isActive = _a.isActive, onClick = _a.onClick;
    return (React.createElement(Stack, { direction: "row", alignItems: "stretch", onClick: onClick, sx: {
            position: 'relative',
            flex: splitAmounts && splitAmounts.length > 1 ? '1.5 1 370px' : '1 1 240px',
            minWidth: 0,
            maxWidth: splitAmounts && splitAmounts.length > 1 ? 400 : 290,
            overflow: 'hidden',
            borderRadius: 2,
            backgroundColor: isActive ? "".concat(color, "0D") : baseColors.fullWhite,
            border: "1px solid ".concat(isActive ? color : baseColors.greyPreset[40]),
            borderLeft: "3px solid ".concat(color),
            cursor: onClick ? 'pointer' : 'default',
            transition: 'all 0.15s ease',
            '&:hover': onClick ? { borderColor: color } : undefined,
        } },
        React.createElement(Stack, { sx: {
                width: 60,
                flexShrink: 0,
                py: 1,
                gap: 0.5,
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: baseColors.greyPreset[50],
            } },
            React.createElement(Icon, { size: 18, color: color, strokeWidth: 2 }),
            React.createElement(Typography, { sx: { fontSize: 22, fontWeight: 800, color: baseColors.darkPreset[10], lineHeight: 1.1 } }, count === undefined ? '—' : String(count).padStart(2, '0'))),
        React.createElement(Stack, { sx: { minWidth: 0, px: 1.25, py: 1.2, gap: 0.4, justifyContent: 'center' } },
            React.createElement(Stack, { direction: "row", alignItems: "center", gap: 0.75, sx: { minWidth: 0, mb: 0.75 } },
                React.createElement(Typography, { noWrap: true, sx: { fontSize: 13, fontWeight: 700, color: color, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' } }, label),
                newCount !== undefined && newCount > 0 && React.createElement(FundingLogNewTag, null, "+".concat(newCount, " new"))),
            splitAmounts ? (React.createElement(Stack, { direction: "row", alignItems: "baseline", columnGap: 2.5, rowGap: 0.5, flexWrap: "wrap", sx: { minWidth: 0 } }, splitAmounts.map(function (_a) {
                var splitAmount = _a.amount, currency = _a.currency;
                return (React.createElement(Stack, { key: currency, direction: "row", alignItems: "baseline", gap: 0.5, sx: { minWidth: 0 } },
                    React.createElement(Typography, { noWrap: true, sx: { fontSize: 16, fontWeight: 800, color: baseColors.darkPreset[10], lineHeight: 1.2 } }, formatCurrency(splitAmount)),
                    React.createElement(Typography, { noWrap: true, sx: { fontSize: 10, fontWeight: 600, color: baseColors.greyPreset[30] } }, currency)));
            }))) : !hideEmptyAmount && (React.createElement(Stack, { direction: "row", alignItems: "baseline", gap: 0.5, sx: { minWidth: 0 } },
                React.createElement(Typography, { noWrap: true, sx: { fontSize: 16, fontWeight: 800, color: baseColors.darkPreset[10], lineHeight: 1.2 } }, amount === undefined ? '—' : formatCurrency(amount)),
                amount !== undefined && currencyLabel && (React.createElement(Typography, { noWrap: true, sx: { fontSize: 10, fontWeight: 600, color: baseColors.greyPreset[30] } }, currencyLabel)))))));
};
var QueueTabBar = function (_a) {
    var tabs = _a.tabs, activeIndex = _a.activeIndex, onTabChange = _a.onTabChange, trailingContent = _a.trailingContent;
    return (React.createElement(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 2 },
        React.createElement(Stack, { direction: "row", gap: 0.4, flexWrap: "wrap", sx: { p: 0.4, borderRadius: 2.5, backgroundColor: baseColors.greyPreset[50] } }, tabs.map(function (tab, index) {
            var isActive = index === activeIndex;
            return (React.createElement(Stack, { key: tab.label, direction: "row", alignItems: "center", gap: 0.6, onClick: function () { return onTabChange(index); }, sx: {
                    px: 1.25,
                    py: 0.5,
                    borderRadius: 2,
                    cursor: 'pointer',
                    backgroundColor: isActive ? baseColors.fullWhite : 'transparent',
                    boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                } },
                React.createElement(Typography, { sx: { fontSize: 13, fontWeight: isActive ? 700 : 500, color: isActive ? baseColors.darkPreset[10] : baseColors.greyPreset[10] } }, tab.label),
                tab.count !== undefined && (React.createElement(Box, { sx: {
                        px: 0.6,
                        minWidth: 18,
                        textAlign: 'center',
                        borderRadius: 10,
                        backgroundColor: isActive ? baseColors.greyPreset[45] : baseColors.greyPreset[40],
                        fontSize: 11,
                        fontWeight: 700,
                        color: baseColors.darkPreset[10],
                        lineHeight: '16px',
                    } }, tab.count))));
        })),
        trailingContent));
};
var FundingLogManagement = function () {
    var _a, _b, _c, _d;
    var _e = useState(false), filterOpen = _e[0], setFilterOpen = _e[1];
    var _f = useState(0), activeTab = _f[0], setActiveTab = _f[1];
    var _g = useState(null), queueOverride = _g[0], setQueueOverride = _g[1];
    var _h = useState(false), isDetailsPanelOpen = _h[0], setIsDetailsPanelOpen = _h[1];
    var _j = useState(null), detailsPanelContainer = _j[0], setDetailsPanelContainer = _j[1];
    var refreshFnRef = useRef(function () { });
    var _k = useState(null), lastRefreshedAt = _k[0], setLastRefreshedAt = _k[1];
    var _l = useState(false), isRefreshing = _l[0], setIsRefreshing = _l[1];
    var _m = useState({}), newCounts = _m[0], setNewCounts = _m[1];
    var _o = useState(0), forceRelativeTimeTick = _o[1];
    React.useEffect(function () {
        var intervalId = window.setInterval(function () { return forceRelativeTimeTick(function (tick) { return tick + 1; }); }, 15000);
        return function () { return window.clearInterval(intervalId); };
    }, []);
    var formatRefreshedAgo = function (date) {
        var diffSec = Math.max(0, Math.round((Date.now() - date.getTime()) / 1000));
        if (diffSec < 5)
            return 'just now';
        if (diffSec < 60)
            return "".concat(diffSec, " sec ago");
        var diffMin = Math.round(diffSec / 60);
        if (diffMin < 60)
            return "".concat(diffMin, " min ago");
        var diffHr = Math.round(diffMin / 60);
        return "".concat(diffHr, " hr ago");
    };
    var roleDescription = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleDescription; });
    var roleType = useSelector(function (store) { var _a; return (_a = store.User.userData) === null || _a === void 0 ? void 0 : _a.RoleType; });
    var isSalesSupport = roleType === 'SALES_SUPPORT';
    var isReviewer = isFundingLogReviewerRole(roleDescription);
    var hasMyQueue = isReviewer || isSalesSupport;
    var queueTabs = useMemo(function () {
        var baseTabs = (deriveFundingLogRoleTier(roleDescription) === 'L2' || !isReviewer) ? L2_QUEUE_TABS : L1_QUEUE_TABS;
        return baseTabs.filter(function (tab) { return ((hasMyQueue || tab.queueType !== 'MY_QUEUE')
            && !(isSalesSupport && tab.queueType === 'L2_REVIEW_QUEUE')); });
    }, [roleDescription, isReviewer, hasMyQueue, isSalesSupport]);
    var safeActiveTab = Math.min(activeTab, queueTabs.length - 1);
    var effectiveQueueType = (_b = queueOverride !== null && queueOverride !== void 0 ? queueOverride : (_a = queueTabs[safeActiveTab]) === null || _a === void 0 ? void 0 : _a.queueType) !== null && _b !== void 0 ? _b : 'ALL';
    var _p = useState({
        hasActiveFilters: false,
        chips: [],
        country: null,
    }), filterState = _p[0], setFilterState = _p[1];
    var _q = useState({}), queueCounts = _q[0], setQueueCounts = _q[1];
    var _r = useState({}), queueAmounts = _r[0], setQueueAmounts = _r[1];
    var _s = useState({}), inProgressCountryAmounts = _s[0], setInProgressCountryAmounts = _s[1];
    var _t = useState(undefined), activeTabTotalCount = _t[0], setActiveTabTotalCount = _t[1];
    var exportFnRef = useRef(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2];
    }); }); });
    var activeViewLabel = (queueOverride && ((_c = QUEUE_SUMMARY_CARDS.find(function (card) { return card.queueType === queueOverride; })) === null || _c === void 0 ? void 0 : _c.label))
        || ((_d = queueTabs[safeActiveTab]) === null || _d === void 0 ? void 0 : _d.label)
        || 'All';
    var viewTotalCount = activeTabTotalCount !== null && activeTabTotalCount !== void 0 ? activeTabTotalCount : queueCounts[effectiveQueueType];
    var exportSummary = "".concat(viewTotalCount === undefined ? 'All deals' : "".concat(viewTotalCount, " ").concat(viewTotalCount === 1 ? 'deal' : 'deals'), " in ").concat(activeViewLabel)
        + (filterState.hasActiveFilters ? ', using your current filters' : '');
    var trailingContent = (React.createElement(Stack, { direction: "row", alignItems: "center", gap: 2, className: "backlog-toolbar-controls", sx: { minWidth: 0, flexWrap: 'nowrap' } },
        React.createElement(Box, { sx: { minWidth: 0, flexShrink: 0 } },
            React.createElement(ActiveFilterChipsRow, { chips: filterState.chips, onOverflowClick: function () { return setFilterOpen(true); }, onClearAll: function () { } })),
        lastRefreshedAt && (React.createElement(Tooltip, { title: "Last updated: ".concat(moment(lastRefreshedAt).format('MMM D, YYYY, h:mm A')) },
            React.createElement(Typography, { variant: "body2", sx: {
                    color: baseColors.greyPreset[5],
                    flexShrink: 0,
                    whiteSpace: 'nowrap',
                    cursor: 'default',
                } },
                "Last refreshed ",
                formatRefreshedAgo(lastRefreshedAt)))),
        !EXPORT_HIDDEN_QUEUE_TYPES.includes(effectiveQueueType) && (React.createElement(ExportMenuButton, { summary: exportSummary, disabled: viewTotalCount === 0, onExport: function (format) { return exportFnRef.current(format, activeViewLabel); } })),
        React.createElement(CustomButton, { MDButton: true, variant: "outlined", startIcon: React.createElement(Box, { component: "span", sx: { display: 'inline-flex', '& path': { fill: 'none !important' } } },
                React.createElement(RefreshCcw, { size: 16, style: {
                        display: 'inline-flex',
                        animation: isRefreshing ? "".concat(refreshSpin, " 0.8s linear infinite") : undefined,
                    } })), onClick: function () { return refreshFnRef.current(); }, disabled: isRefreshing, fullWidth: false, iconSize: 18, sx: { flexShrink: 0 } }, isRefreshing ? 'Refreshing…' : 'Refresh'),
        React.createElement(CustomButton, { MDButton: true, variant: filterState.hasActiveFilters ? 'contained' : 'outlined', startIcon: React.createElement("span", { className: 'icon-Filters' }), onClick: function () { return setFilterOpen(function (prev) { return !prev; }); }, fullWidth: false, iconSize: 18, sx: { flexShrink: 0 } }, "Filter")));
    var getInProgressSplitAmounts = function () {
        var _a;
        var us = inProgressCountryAmounts.us, canada = inProgressCountryAmounts.canada;
        if (us === undefined && canada === undefined)
            return undefined;
        var countryValue = (_a = filterState.country) === null || _a === void 0 ? void 0 : _a.value;
        var lines = [];
        if (us !== undefined && (!countryValue || countryValue === FUNDING_LOG_COUNTRY_OPTIONS[0].value))
            lines.push({ amount: us, currency: 'USD' });
        if (canada !== undefined && (!countryValue || countryValue === FUNDING_LOG_COUNTRY_OPTIONS[1].value))
            lines.push({ amount: canada, currency: 'CAD' });
        return lines.length ? lines : undefined;
    };
    var queueSummaryCards = useMemo(function () { return QUEUE_SUMMARY_CARDS.filter(function (card) { return ((hasMyQueue || card.queueType !== 'MY_QUEUE')
        && !(isSalesSupport && card.queueType === 'UNASSIGNED')); }); }, [hasMyQueue, isSalesSupport]);
    var allQueueTypes = useMemo(function () {
        var combined = __spreadArray(__spreadArray([], queueTabs.map(function (tab) { return tab.queueType; }), true), queueSummaryCards.map(function (card) { return card.queueType; }), true);
        return Array.from(new Set(combined));
    }, [queueTabs, queueSummaryCards]);
    var handleAssignedToMyselfFromDrawer = function () {
        var myQueueIndex = queueTabs.findIndex(function (tab) { return tab.queueType === 'MY_QUEUE'; });
        if (myQueueIndex !== -1) {
            setActiveTab(myQueueIndex);
            setQueueOverride(null);
        }
    };
    var location = useLocation();
    var restoredQueueTypeRef = useRef(false);
    React.useEffect(function () {
        var _a;
        var restoreQueueType = (_a = location.state) === null || _a === void 0 ? void 0 : _a.queueType;
        if (restoredQueueTypeRef.current || !restoreQueueType || !queueTabs.length)
            return;
        restoredQueueTypeRef.current = true;
        if (!allQueueTypes.includes(restoreQueueType))
            return;
        var tabIndex = queueTabs.findIndex(function (tab) { return tab.queueType === restoreQueueType; });
        if (tabIndex !== -1) {
            setActiveTab(tabIndex);
            return;
        }
        var inProgressIndex = queueTabs.findIndex(function (tab) { return tab.queueType === 'IN_PROGRESS'; });
        if (inProgressIndex !== -1)
            setActiveTab(inProgressIndex);
        setQueueOverride(restoreQueueType);
    }, [location.state, queueTabs, allQueueTypes]);
    var handleTabChange = function (index) {
        if (index === safeActiveTab && !queueOverride)
            return;
        setActiveTab(index);
        setQueueOverride(null);
        setActiveTabTotalCount(undefined);
    };
    var handleSummaryCardClick = function (targetQueueType) {
        if (targetQueueType === effectiveQueueType)
            return;
        setActiveTabTotalCount(undefined);
        var matchingTabIndex = queueTabs.findIndex(function (tab) { return tab.queueType === targetQueueType; });
        if (matchingTabIndex !== -1) {
            setActiveTab(matchingTabIndex);
            setQueueOverride(null);
            return;
        }
        var inProgressIndex = queueTabs.findIndex(function (tab) { return tab.queueType === 'IN_PROGRESS'; });
        if (inProgressIndex !== -1)
            setActiveTab(inProgressIndex);
        setQueueOverride(targetQueueType);
    };
    var sharedFundingLogContent = (React.createElement(FundingLog, { filterOpen: filterOpen, onCloseFilter: function () { return setFilterOpen(false); }, queueType: effectiveQueueType, allQueueTypes: allQueueTypes, onFilterStateChange: setFilterState, onQueueCountChange: setQueueCounts, onQueueAmountChange: setQueueAmounts, onInProgressCountryAmountsChange: setInProgressCountryAmounts, onTotalCountChange: setActiveTabTotalCount, onAssignedToMyselfFromDrawer: handleAssignedToMyselfFromDrawer, onRefreshReady: function (refresh) { refreshFnRef.current = refresh; }, onExportReady: function (exportRows) { exportFnRef.current = exportRows; }, onLastRefreshedChange: setLastRefreshedAt, onFetchingChange: setIsRefreshing, onNewCountsChange: setNewCounts, onDetailsPanelOpenChange: setIsDetailsPanelOpen, detailsPanelContainer: detailsPanelContainer }));
    var tabItems = queueTabs.map(function (tab, index) { return ({
        label: tab.label,
        count: index === safeActiveTab ? (activeTabTotalCount !== null && activeTabTotalCount !== void 0 ? activeTabTotalCount : queueCounts[tab.queueType]) : queueCounts[tab.queueType],
    }); });
    return (React.createElement(Box, { pt: 1, sx: { height: 'calc(100vh - 45px)', display: 'flex', overflow: 'hidden' } },
        React.createElement(Box, { className: "backlogApplicationWrapper", sx: { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' } },
            React.createElement(Stack, { pl: 1.5, pr: isDetailsPanelOpen ? 1.5 : 1.5, sx: { flex: 1, minHeight: 0, overflow: 'hidden' } },
                React.createElement(Stack, { gap: 1.25, sx: { flexShrink: 0 } },
                    React.createElement(Stack, { direction: "row", gap: 1.25, flexWrap: "nowrap" }, queueSummaryCards.map(function (card) { return (React.createElement(QueueSummaryCard, { key: card.queueType, label: card.label, count: queueCounts[card.queueType], amount: card.queueType === 'IN_PROGRESS' || filterState.country ? queueAmounts[card.queueType] : undefined, hideEmptyAmount: card.queueType !== 'IN_PROGRESS' && !filterState.country, splitAmounts: card.queueType === 'IN_PROGRESS' ? getInProgressSplitAmounts() : undefined, currencyLabel: filterState.country ? (filterState.country.value === FUNDING_LOG_COUNTRY_OPTIONS[1].value ? 'CAD' : 'USD') : undefined, newCount: newCounts[card.queueType], color: card.color, icon: card.icon, isActive: effectiveQueueType === card.queueType, onClick: function () { return handleSummaryCardClick(card.queueType); } })); })),
                    React.createElement(QueueTabBar, { tabs: tabItems, activeIndex: safeActiveTab, onTabChange: handleTabChange, trailingContent: trailingContent })),
                React.createElement(Box, { sx: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' } }, sharedFundingLogContent))),
        isDetailsPanelOpen && (React.createElement(FundingLogDetailsPanelWrapper, { ref: setDetailsPanelContainer, sx: { mr: 1.5 } }))));
};
export default FundingLogManagement;
var templateObject_1;
